import {ReactNode} from 'react';
import {VerifiedPermissionsProvider} from '@flexinet/auth-components';
import permissions from '../config/permissions.ts';
import {actions} from '../config/rbac/actions.ts';
import {useAuth} from '../hooks/useAuth.ts';

// Feeds the shared provider from this app's own AuthContext (FNP-1730). The
// library resolves no session itself: until `status` is 'authenticated' it
// makes no AVP call, so a signed-out load no longer throws for a missing
// idToken.
export const PermissionsProvider = ({children}: { children?: ReactNode }) => {
    const {
        status,
        user
    } = useAuth();

    return (
        <VerifiedPermissionsProvider
            actions={actions}
            policyStoreId={permissions.policyStoreId}
            region={permissions.region}
            actionType={`${permissions.namespace}::Action`}
            enabled={permissions.enabled}
            sessionStatus={status}
            sessionKey={status === 'authenticated' ? user?.userId : undefined}
        >
            {children}
        </VerifiedPermissionsProvider>
    );
};
